import Factory from '../utils/factory'
import Person from '../Person'

export default Factory({
  type: 'bid',
  document: null,
  data: {
    applicant: Person(),
    hasCoApplicant: false,
    coApplicant: Person(),
    amount: null,
  },
})
